import { AttendeeProcessingUrlResponse } from '../../api';
import { AttendeeUrlProcessingPolling } from './attendee-url-processing-polling';

export type SubscriptionFallbackOptions = {
  isClientClosed(): boolean;
  createPolling(): AttendeeUrlProcessingPolling;
  onPollingResult(pollingResponse: AttendeeProcessingUrlResponse): void;
  startDelay: number;
}

export type SubscriptionFallback = {
  start(): void;
  stop(): void;
}

export const createSubscriptionFallback = ({ isClientClosed, createPolling, onPollingResult, startDelay }: SubscriptionFallbackOptions): SubscriptionFallback => {
  let timerId: number | null = null;
  let polling: AttendeeUrlProcessingPolling | null = null;

  const start = (): void => {
    if (timerId || polling || isClientClosed()) return;

    timerId = window.setTimeout(() => {
      timerId = null;
      if (isClientClosed()) return;

      polling = createPolling();
      polling.start()
        .then((pollingResponse) => {
          if (isClientClosed()) return;
          onPollingResult(pollingResponse);
        })
        .catch(() => {
          polling = null;
        });
    }, startDelay);
  };

  const stop = (): void => {
    if (timerId) {
      window.clearTimeout(timerId);
      timerId = null;
    }
    polling?.stop();
    polling = null;
  };

  return { start, stop };
};
